export type ColorMode = 'solid' | 'gradient'

export const DEFAULT_ENTITY_COLORS = [
  '#6366F1',
  '#0EA5E9',
  '#8B5CF6',
  '#EC4899',
  '#F59E0B',
  '#10B981',
  '#64748B',
  '#FFD400',
] as const
